module.exports = __webpack_public_path__ + "static/media/BNW_Alphabet_F.ca53f92e.jpg";